import React, { Component } from "react";
import PropTypes from "prop-types";

class Counter extends Component {
  static propTypes = {
    hasHours: PropTypes.bool,
    onFinish: PropTypes.func,
    time: PropTypes.number.isRequired
  };

  static defaultProps = {
    hasHours: false,
    onFinish: () => {}
  };

  constructor(props) {
    super(props);

    this.timer = null;

    this.state = {
      counter: props.time
    };
  }

  componentDidMount() {
    this.timer = setInterval(this.tick, 1000);
  }

  shouldComponentUpdate() {
    return true;
  }

  componentWillUnmount() {
    this.clear();
  }

  tick = () => {
    const { onFinish } = this.props;
    if (this.state.counter >= 1000) {
      this.setState(prevState => ({
        counter: prevState.counter - 1000
      }));
    } else {
      this.clear();

      if (onFinish) {
        onFinish();
      }
    }
  };

  clear = () => {
    this.timer = null;
    clearInterval(this.timer);
  };

  padTime = time => {
    return `${time < 10 ? "0" : ""}${time}`;
  };

  millisecondsToMinutesAndSeconds = milliseconds => {
    const { hasHours } = this.props;

    const hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((milliseconds / (1000 * 60)) % 60);
    const seconds = Math.floor((milliseconds / 1000) % 60 );
    /* eslint-disable no-nested-ternary */
    return `${hasHours ? `${this.padTime(hours)}:` : ""}${this.padTime(
      minutes
    )}:${this.padTime(seconds)}`;
    /* eslint-enable */
  };

  render() {
    const { hasHours, onFinish, time, ...rest } = this.props;
    const { counter } = this.state;

    return <p {...rest}>{this.millisecondsToMinutesAndSeconds(counter)}</p>;
  }
}

export default Counter;
